export default __webpack_public_path__ + "static/IMG_8966-a245d5029d69228355e4b1771caa1005.png";